import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import { reportingCategories } from "../../utils/categories";

const initialState = {
  category: reportingCategories,
};

export default function(state = initialState, action) {
  switch (action.type) {
    default:
      break;
  }
  return state;
}
